import React from 'react';

function isNumeric(num) {
  return !isNaN(parseFloat(num));
}

const Money = ({ value, defaultValue = '', currency, locale }) => {
  return isNumeric(value) ? (
    value.toFormattedMoney(locale, currency, defaultValue)
  ) : (
    <span>{defaultValue}</span>
  );
};

export default Money;



// WEBPACK FOOTER //
// ./src/app/components/Money/index.jsx